import { copyToClipboard, stanAnalytics } from '@/lib';
import { ChatSession } from '../types/askStanley.types';

export interface CopyMessageParams {
    messageId: string | number;
    currentChatId: string | number;
    chats: ChatSession[];
    user?: { user_id?: string | number; username?: string };
}

/**
 * Handles copying a message to clipboard
 * Pure business logic - no direct store access
 */
export async function handleCopyMessage(params: CopyMessageParams): Promise<void> {
    const { messageId, currentChatId, chats, user } = params;

    const currentChat = chats.find(chat => chat.id === currentChatId);
    const message = currentChat?.messages.find(msg => msg.id === messageId);

    if (message) {
        // Track copy event
        stanAnalytics('chat-v2-copy', {
            meta: { user_id: user?.user_id, username: user?.username },
            props: {
                chat_id: currentChatId,
                message_id: messageId,
                platform: typeof window !== 'undefined' && window.innerWidth < 768 ? 'mobile' : 'desktop',
            },
        });

        // Extract plain text from HTML if content_html exists (matching Vue behavior)
        let textToCopy = message.content;
        if (message.content_html) {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = message.content_html;
            textToCopy = tempElement.textContent || tempElement.innerText || message.content;
        }

        await copyToClipboard(textToCopy, {
            successMessage: 'Message copied!',
            errorMessage: 'Failed to copy message',
        });
    }
}
